import {createStore} from "vuex"
import {commonStore} from "./commonStore"

export default createStore({
	modules: {
		common: commonStore,
		test: commonStore,
	},
})
